<div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="RequestDetailsList.length > 0">
        <p-table #dt [columns]="cols"
                 [value]="RequestDetailsList"
                 [(selection)]="SelectedRequestDetailsList"
                 [loading]="loading"
                 [paginator]="true"
                 [rows]="10"
                 autoLayout="true"
                 responsive="true"
                 [first]="first"
                 (onPage)="paginate($event)">
            <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix">
                    <span style="float:left;">
                        <p-radioButton name="group2" value="1" label="1 Resume Per Page " [(ngModel)]="ResumePerPageSelected" inputId="preopt1"></p-radioButton>&nbsp;
                        <p-radioButton name="group2" value="2" label="2 Resume Per Page " [(ngModel)]="ResumePerPageSelected" inputId="preopt2"></p-radioButton>&nbsp;
                        <p-radioButton name="group2" value="3" label="3 Resume Per Page " [(ngModel)]="ResumePerPageSelected" inputId="preopt3"></p-radioButton>&nbsp;
                    </span>
                    <span style="float:right">
                        <button type="button"
                                pButton icon="fa fa-envelope-o"
                                iconPos="left"
                                label="Generate Resume"
                                style="float:left"
                                (click)="GenerateResume()"
                                [disabled]="SelectedRequestDetailsList.length<=0"></button>
                        <button pButton
                                icon="fa fa-cart-arrow-down"
                                iconPos="left"
                                type="button"
                                label="Reset Cart"
                                (click)="ResetCart()"
                                style="float:left"></button>
                        <!--<button type="button"
                                pButton icon="fa fa-file-excel-o"
                                iconPos="left"
                                label="Export All"
                                (click)="dt.exportCSV()"
                                style="float:right"
                                [disabled]="RequestDetailsList.length<=0"></button>-->
                        <button type="button"
                                pButton icon="fa fa-window-close-o"
                                iconPos="left"
                                label="Exit"
                                style="float:left" [routerLink]="['/home/dashboard']"></button>
                    </span>

                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th>
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <ng-container *ngFor="let col of columns">
                        <th [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [pSelectableRow]="rowData">
                    <td style="vertical-align:top;">
                        <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                    </td>
                    <ng-container *ngFor="let col of columns">
                        <td style="vertical-align:top;">
                            <ng-container *ngIf="col.field==='ResumeId';else second">
                                <a style="color:blue;cursor: pointer;"
                                   (click)="onCickRequestNumber(rowData.ResumeId)">{{rowData[col.field]}}</a>
                            </ng-container>
                            <ng-template #second>
                                {{rowData[col.field]}}
                            </ng-template>
                        </td>
                    </ng-container>
                </tr>
            </ng-template>
        </p-table>

    </div>
    <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="RequestDetailsList.length <= 0">
        <br />
        <br />
        <span style="color:red !important">Your cart is empty.</span>
        <span style="font-style:italic;"><a [routerLink]="['/home/SearchResume']"> Search & add Items to Cart</a></span>
    </div>
</div>